<template>
  <div class="tag">
    <div class="container">
      <div class="tag__wrapper">
        <div class="tag__top">
          <h2 class="tag__title">{{ t(tagTitle + '.title1') }}</h2>
          <ui-button>
            <router-link :to="translations.i18nRoute({ name: 'market' })">
              {{ t('buttons.allCard') }}
            </router-link>
            <img src="@icons/rightArrowBlue.svg" alt="arrow">
          </ui-button>
        </div>
        <div class="swiper">
          <div class="swiper-scrollbar" ref="scrollbarRef"></div>
          <swiper
              :key="products.length"
              class="swiper__wrapper"
              :modules="[Scrollbar]"
              :scrollbar="{
                    el: scrollbarRef,
                    draggable: true,
                    snapOnRelease: true,
                    dragSize: 18
              }"
              :loop="false"
              :speed="500"
              :spaceBetween="20"
              :breakpoints="{
              100: {
                slidesPerView: 1
              },
              400: {
                slidesPerView: 2
              },
              700: {
                slidesPerView: 3
              },
              1000: {
                slidesPerView: 4
              },
              1300: {
                slidesPerView: 5
              }
            }"
          >
            <swiper-slide
                class="swiper__slide"
                v-for="product in products"
                :key="product.node.uuid"
            >
              <router-link
                  class="product-card"
                  :to="translations.i18nRoute({ name: 'product', params: { productSlug: product.node.slug } })"
              >
                <img
                    class="product-card__image"
                    :src="product.node.images.edges[0]?.node.image"
                    :alt="product.node.name"
                />
                <div class="product-card__overlay">
                  <span class="product-card__title">
                    {{ product.node.name }}
                  </span>
                  <span class="product-card__price">
                    {{ product.node.price }}€
                  </span>
                </div>
              </router-link>
            </swiper-slide>

          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css/scrollbar';
import 'swiper/css';
import { Scrollbar } from 'swiper/modules';
import {Products} from "@/core/api/products.js";
import {onMounted, ref} from "vue";
import translations from "@/core/helpers/translations.js";
import UiButton from "@/components/ui/ui-button.vue";

const props = defineProps({
  tag: String,
  tagTitle: String
})

const scrollbarRef = ref()

const {t} = useI18n()

const products = ref([])

const getProducts = async () => {
  const res = await Products.getProducts(`tags: "${props.tag}", first: 12`)
  products.value = res.data.products.edges
}

onMounted( async () => {
  await getProducts()
})
</script>

<style lang="scss" scoped>
.tag {
  padding-top: 100px;

  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;

    & button{
      border: #3B3B3B 1px solid;

      &:hover{
        border: #6F6DD3 1px solid;
        box-shadow: 0 0 5px 1px #6F6DD3;;
      }
    }

    & a {
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 5px;

      color: #3B3B3B;
      font-size: 15px;
      font-weight: 400;
      line-height: 18px;


      @include hover {
        & svg {
          transform: rotate(1turn);
        }
      }
    }
  }

  &__title {
    padding-bottom: 10px;

    font-size: 24px;
    font-weight: 800;
    line-height: 30px;

    color: #DD6196;

  }
}

:deep(.swiper-scrollbar) {
  background: #AAABF3;
  border-radius: 10px;
  height: 10px;
  width: 100%;
  bottom: 0;
  left: 0;
  position: relative;
  overflow: visible;
}

:deep(.swiper-scrollbar-drag) {
  position: absolute;
  top: -4px;
  background: #DD6196;
  border-radius: 50%;
  height: 18px;
  cursor: pointer;
}



.swiper {
  padding-top: 10px;

  &__wrapper {
    padding-block: 40px;
  }

  &__slide {
    & img {
      width: 90%;
      object-fit: cover;
      border-radius: 16px;
    }
  }
}

@media (max-width: 500px) {
  .tag {
    &__title {
      padding-bottom: 5px;
      font-size: 20px;
    }
  }
}

.product-card {
  position: relative;
  display: block;
  overflow: hidden;
  border-radius: 16px;

  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform .4s ease;
  }

  .product-card__overlay {
    position: absolute;
    inset: 0;
    width: 90%;
    border-radius: 16px;
    padding: 19px;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    background: linear-gradient(
            to bottom,
            rgba(0,0,0,0.5),
            rgba(0,0,0,0.1) 40%,
            rgba(0,0,0,0.6)
    );

    opacity: 1;
  }

  &__title,
  &__price {
    color: #fff;
    font-weight: 600;
  }

  &:hover {

    .product-card__overlay {
      opacity: 1;
    }
  }
}

@media (hover: hover) {

  .product-card__overlay {
    opacity: 0;
    transition: opacity .3s ease;
  }

  .product-card:hover .product-card__overlay {
    opacity: 1;
  }

}
</style>